import React, { useState } from 'react';
import { InfoIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface TooltipProps {
  content: string;
  children?: React.ReactNode;
}
export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children
}) => {
  const [isVisible, setIsVisible] = useState(false);
  return <div className="relative inline-flex items-center" data-id="element-463" data-mp="13ul5l74fuejf">
      <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} className="cursor-help" data-id="element-464" data-mp="oyvfaws7zf8w">
        {children || <InfoIcon className="h-3.5 w-3.5 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-465" data-mp="tyrjaw0x36og" />}
      </div>
      <AnimatePresence data-id="element-466" data-mp="fz8of4x49ru3">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 5
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 5
      }} transition={{
        duration: 0.15
      }} className="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-50 pointer-events-none" data-id="element-467" data-mp="g0a3dkh96yh3">
            <div className="bg-gray-900 text-white text-[11px] normal-case rounded-none px-3 py-2 shadow-lg max-w-xl whitespace-normal" data-id="element-468" data-mp="m6qy9zp87dfw">
              {content}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 -mb-1" data-id="element-469" data-mp="i4x48a9jd7op">
                <div className="border-4 border-transparent border-b-gray-900" data-id="element-470" data-mp="vv90mld5lsln" />
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};